const API_BASE_URL = `${process.env.REACT_APP_API_URL}`;

export const studentService = {
  async fetchStudentRecords(searchParams = {}, signal = null) {
    try {
      // Build query parameters
      const params = new URLSearchParams();

      // Add pagination parameters with defaults
      params.append('page', searchParams.page || 1);
      params.append('limit', searchParams.limit || 10);

      // Add sorting parameters with defaults
      if (searchParams.sortBy) {
        params.append('sortBy', searchParams.sortBy);
      }
      if (searchParams.sortOrder) {
        params.append('sortOrder', searchParams.sortOrder);
      }

      // Add search parameters
      if (searchParams.searchField && searchParams.searchValue) {
        params.append('searchField', searchParams.searchField);
        params.append('searchValue', searchParams.searchValue);
      }

      // Add filters (matching your controller)
      if (searchParams.jobReqStatus !== undefined && searchParams.jobReqStatus !== null) {
        if (Array.isArray(searchParams.jobReqStatus)) {
          params.append('jobReqStatus', searchParams.jobReqStatus.join(',')); // ⬅️ MULTI
        } else {
          params.append('jobReqStatus', searchParams.jobReqStatus);
        }
      }
      if (searchParams.department) params.append('department', searchParams.department);
      if (searchParams.skillSet) params.append('skillSet', searchParams.skillSet);
      if (searchParams.experienceRequired) params.append('experienceRequired', searchParams.experienceRequired);
      if (searchParams.jobLocation) params.append('jobLocation', searchParams.jobLocation);
      if (searchParams.createdBy) params.append('createdBy', searchParams.createdBy);
      if (searchParams.allowedBranches) params.append('allowedBranches', searchParams.allowedBranches);  // ⬅️ NEW
      if (searchParams.fromDate) params.append('fromDate', searchParams.fromDate);  // ⬅️ NEW
      if (searchParams.toDate) params.append('toDate', searchParams.toDate);

      const queryString = params.toString();
      const url = `${API_BASE_URL}/job-details?${queryString}`; // Updated endpoint to match controller

      console.log('Fetching URL:', url);
      console.log('Search params:', searchParams);

      const token = localStorage.getItem('token');

      const fetchOptions = {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      };

      // Add abort signal if provided
      if (signal) {
        fetchOptions.signal = signal;
      }

      const response = await fetch(url, fetchOptions);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      console.log('API Response:', result);

      if (result.success && result.data) {
        return {
          data: result.data,
          pagination: result.pagination || {
            currentPage: 1,
            totalPages: 1,
            totalRecords: result.data.length,
            recordsPerPage: result.data.length,
            recordsOnCurrentPage: result.data.length,
            hasNextPage: false,
            hasPrevPage: false
          },
          totalRecords: result.pagination?.totalRecords || result.data.length
        };
      } else {
        return {
          data: [],
          pagination: {
            currentPage: 1,
            totalPages: 1,
            totalRecords: 0,
            recordsPerPage: 10,
            recordsOnCurrentPage: 0,
            hasNextPage: false,
            hasPrevPage: false
          },
          totalRecords: 0
        };
      }
    } catch (error) {
      if (error.name === 'AbortError') {
        throw error; // Re-throw abort errors
      }
      console.error('Error fetching placement records:', error);
      throw new Error('Failed to fetch placement records. Please try again later.');
    }
  }
};